
import { defineComponent, ref } from 'vue';
import Axios from '@/core/services/Http';
import { useStore } from 'vuex';
import { Notify } from '@/core/services';
import { useI18n } from 'vue-i18n';
import InnerLoader from '@/components/InnerLoader.vue';

export default defineComponent({
    name: 'ProductGroups',
    components: {
        InnerLoader
    },
    setup() {
        const store = useStore();
        const i18n = useI18n();
        const loading = ref(false);

        const getProductGroups = () => {
            store.getters.appInstance.$messageBox
                .confirm(`${i18n.t('message.ARE_YOU_SURE_TO_SYNC_PRODUCT_GROUPS')}?`, i18n.t('message.INFO'), {
                    confirmButtonText: i18n.t('message.OK'),
                    cancelButtonText: i18n.t('message.CANCEL'),
                    type: 'info'
                })
                .then(async () => {
                    loading.value = true;
                    try {
                        await Axios.get(`/stellini/get-product-groups`);
                        Notify.success(i18n.t('message.PRODUCT_GROUPS_SYNCING_STARTED'));
                    } catch ($e) {
                        Notify.error($e);
                    } finally {
                        loading.value = false;
                    }
                })
                .catch(() => {
                    loading.value = false;
                });
        };

        return {
            loading,
            getProductGroups
        };
    }
});
